export default "__VITE_ASSET__DEVjrwzY__"